import { Category } from '@graphql/generated-base';
import type { OverrideTypography } from '../GuestSiteTypographyOverride/GuestSiteTypographyOverride.types';

// Shared primitives for the event-name title banner, rendered by both the website header
// (EventNameNav) and the standalone registry header (CoupleHeader, cloned from it). Shared so the
// clone can't drift again — it did, leaving the registry banner 91px taller (PRNT-4748).

// Both variants map to EVENT_TITLE so the title can shrink below xs without losing the couple's
// font choice. The step-down itself lives in `useEventNameTitleVariant`.
export const EVENT_TITLE_TYPOGRAPHY_OVERRIDE: OverrideTypography = [
  { variant: 'display6', category: Category.EVENT_TITLE },
  { variant: 'display4', category: Category.EVENT_TITLE },
];

// Banner min-height per breakpoint. The xs breakpoint is 375 inside the preview iframe and 480 on
// the guest page, so only the preview needs the taller first value.
const BANNER_MIN_HEIGHT = 200;
const PREVIEW_XS_BANNER_MIN_HEIGHT = 291;
export const getEventNameMinHeight = (isPreviewing: boolean, hasMasthead: boolean): Array<number | string | null> => [
  hasMasthead ? 'unset' : isPreviewing ? PREVIEW_XS_BANNER_MIN_HEIGHT : BANNER_MIN_HEIGHT,
  hasMasthead ? 'unset' : BANNER_MIN_HEIGHT,
  null,
  'initial',
];
